var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9 14C9.2928 14 8.8 13.8258 8.8 13.6111V0.388889C8.8 0.174222 9.2928 0 9.9 0C10.5072 0 11 0.174222 11 0.388889V13.6111C11 13.8258 10.5072 14 9.9 14ZM1.1 14C0.492799 14 0 13.8258 0 13.6111V0.388889C0 0.174222 0.492799 0 1.1 0C1.7072 0 2.2 0.174222 2.2 0.388889V7V13.6111C2.2 13.8258 1.7072 14 1.1 14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon);
export default __webpack_public_path__ + "static/media/pause_icon.3f5d5b350e44c230b91dc8950db02778.svg";
export { ForwardRef as ReactComponent };